/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';

import classes from './Projects.module.scss';
import ImageBG from '../UI/ImageBG/ImageBG';
import Button from '../UI/Button/Button';

function importAll(r) {
  return r.keys().map(r);
}
const images = importAll(require.context('../../assets/projects/', false, /\.(png|jpe?g|svg|webp)$/));

const Projects = () => {
  console.log(images);
  const fadeSettings = {
    bottom: true,
    duration: 1200,
    fraction: 0.8
  };

  const ImageWithLink = ({ src, title, linkText }) => {
    const [hover, setHover] = useState(false);
    const imageBgClasses = [classes.ImageBG, classes.ScaleOnLink];
    if (hover) imageBgClasses.push(classes.Hover);

    return (
      <React.Fragment>
        <ImageBG className={imageBgClasses.join(' ')} src={src} />

        <Fade {...fadeSettings}>
          <div className={classes.LinkTexts} onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}>
            <h3 className={classes.Title}>{title}</h3>
            <Button hover={hover}>{linkText}</Button>
          </div>
        </Fade>
      </React.Fragment>
    );
  };

  const SliderWithLink = ({ title, linkText }) => {
    const sliderIndexes = [1, 7, 9, 10, 12, 16, 17, 18];
    const [activeIndex, setActiveIndex] = useState(Math.floor(Math.random() * sliderIndexes.length));
    const [hover, setHover] = useState(false);

    useEffect(() => {
      setInterval(()=>{
        const nextIndex = Math.floor(Math.random() * sliderIndexes.length);
        setActiveIndex(nextIndex);
      }, 2000);
    }, []);

    return (
      <React.Fragment>
        <div className={classes.Slider}>
          {sliderIndexes.map(i => {
            const imageClasses = [classes.SliderImage];
            if (i === sliderIndexes[activeIndex]) imageClasses.push(classes.Active);

            return <ImageBG key={i} className={imageClasses.join(' ')} src={images[i]} />
          })}
        </div>

        <Fade {...fadeSettings}>
          <div className={classes.LinkTexts} onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}>
            <h3 className={classes.Title}>{title}</h3>
            <Button hover={hover}>{linkText}</Button>
          </div>
        </Fade>
      </React.Fragment>
    );
  };

  const ImageWithTitle = ({ src, title }) => {
    const [transY, setTransY] = useState(-100);
    const titleRef = React.useRef();
    
    useEffect(() => {
      window.addEventListener('scroll', ()=>{
        // console.log(titleRef);
        if (titleRef && titleRef.current) {
          const titleRect = titleRef.current.getBoundingClientRect();

          if (titleRect.y - titleRect.height - window.innerHeight <= 0 &&
            titleRect.y + titleRect.height >= 0) {

          }
          if (titleRect.top - titleRect.height - window.innerHeight <= 0 && titleRect.top + titleRect.height > 0) {
            const minTransY = 0, maxTransY = 200;
            const bgY1 = window.pageYOffset + titleRect.top - window.innerHeight - titleRect.height;
            const bgY2 = bgY1 + window.innerHeight + titleRect.height;
            const bgYP = (window.pageYOffset - bgY1) / (bgY2 - bgY1) * 100;
            const bgTransY = (maxTransY - minTransY) * bgYP / 100;

            setTransY(bgTransY);
          }
        }
      });
    }, []);

    return (<React.Fragment>
      <ImageBG className={[classes.ImageBG, classes.GrayScale].join(' ')} src={src} />
      <div className={classes.Shade}></div>

      <Fade {...fadeSettings}>
        <div className={classes.TextContents} style={{
          width: '100%',
          height: '100%',
          textAlign: 'center',
          cursor: 'pointer',
          padding: '0'
        }}>
          <h2 
            className={classes.TitleTag} 
            style={{transform: `translateY(${transY - 100}%)`}}
            ref={titleRef}
          >{title}</h2>
        </div>
      </Fade>
    </React.Fragment>);
  }

  return (
    <div className={classes.Projects}>
      <div className={classes.Grids}>

        <div className={[classes.Grid, classes.Grid1].join(' ')}>
          <ImageWithLink src={images[8]} title="Teams" linkText="Take a look" />
        </div>
        <div className={[classes.Grid, classes.Grid2].join(' ')}>
          <ImageWithLink src={images[0]} title="Our Services" linkText="Find out more" />
        </div>
        <div className={[classes.Grid, classes.Grid3].join(' ')}>
          <Fade {...fadeSettings}>
            <div className={classes.TextContents}>
              <h2 className={classes.Title}>Over 25 year experience and a proven track record.</h2>
            </div>
          </Fade>
        </div>
        <div className={[classes.Grid, classes.Grid4].join(' ')}>
          <ImageWithTitle src={images[2]} title="Motion" />
        </div>
        <div className={[classes.Grid, classes.Grid5].join(' ')}>
          <ImageWithTitle src={images[15]} title="Portrait" />
        </div>
        <div className={[classes.Grid, classes.Grid6].join(' ')}>
          <ImageWithTitle src={images[4]} title="Advanced" />
        </div>
        <div className={[classes.Grid, classes.Grid7].join(' ')}>
          <ImageWithTitle src={images[5]} title="Art" />
        </div>
        <div className={[classes.Grid, classes.Grid8].join(' ')}>
          <ImageWithTitle src={images[19]} title="Creative" />
        </div>
        <div className={[classes.Grid, classes.Grid9].join(' ')}>
          <ImageWithTitle src={images[11]} title="Nature" />
        </div>
        <div className={[classes.Grid, classes.Grid10].join(' ')}>
          {(() => {
            const AwardTexts = ({ date, text }) => (
              <div className={classes.AwardTexts}>
                <p className={classes.Date}>{date}</p>
                <p className={classes.Text}>{text}</p>
              </div>
            );

            return (
              <div className={classes.TextContents}>
                <AwardTexts date="12 Jun 2020" text="Germany Awards 2020" />
                <AwardTexts date="20 Aug 2019" text="Best Of Portrait Awards 2019 USA" />
                <AwardTexts date="06 Sep 2016" text="Best Photography Contests Awards 2016 in Bangladesh" />
              </div>
            )
          })()}
        </div>
        <div className={[classes.Grid, classes.Grid11].join(' ')}>
          <ImageWithLink src={images[13]} title="Our Models" linkText="View all" />
        </div>
        <div className={[classes.Grid, classes.Grid12].join(' ')}>
          <ImageWithLink src={images[14]} title="Why Us?" linkText="About Us" />
        </div>
        <div className={[classes.Grid, classes.Grid13].join(' ')}>
          <SliderWithLink title="Our Offices" linkText="Take a look" />
        </div>

      </div>
    </div>
  );
}

export default Projects;
